module.exports = __webpack_public_path__ + "img/selectedSoft.16125fb1.png";